const formatCurrency = (number, locale = 'en-ZA', currencyCode = 'ZAR') => {
  if (number === null || number === undefined) {
    return '';
  }

  if (typeof number !== 'number') {
    number = Number(number) || 0;
  }

  return number.toLocaleString(locale, { style: 'currency', currency: currencyCode, minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatNumber = (number, locale = 'en-ZA', minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  if (number === null || number === undefined) {
    return '';
  }

  if (typeof number !== 'number') {
    number = Number(number) || 0;
  }

  return number.toLocaleString(locale, { minimumFractionDigits, maximumFractionDigits });
};

const formatNumbers = (number) => {
  return number.toLocaleString();
};

/**
 * Adds space thousands separators to every numeric run inside a value, leaving the
 * surrounding text untouched so unit-suffixed values ("13.5km", "100%") stay readable.
 *
 * @param {string|number|null|undefined} value
 * @returns {string} e.g. 2000 -> "2 000", "26.1388km" -> "26.1388km"
 */
const formatThousands = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  return String(value).replace(/\d+(?:\.\d+)?/g, (number) => {
    const [integer, decimals] = number.split('.');
    const separated = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return decimals ? `${separated}.${decimals}` : separated;
  });
};

const financialTableFormatters = {
  currency: {
    // Formats 10000 to "10 000" (South African standard for tables)
    format: (v) => {
      if (v === null || v === undefined || v === '') return '';
      return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    // Parses "10 000" back to 10000
    parse: (v) => {
      if (!v) return '';
      return v.toString().replace(/[\s,R]/g, ''); // Removes spaces, commas, and 'R'
    },
  },
  percent: {
    format: (v) => (v !== null && v !== undefined && v !== '') ? `${v}%` : '',
    parse: (v) => v ? v.toString().replace(/%/g, '').trim() : '',
  },
  days: {
    format: (v) => (v !== null && v !== undefined && v !== '') ? `${v} days` : '',
    parse: (v) => v ? v.toString().replace(/days/gi, '').trim() : '',
  },
  months: {
    format: (v) => (v !== null && v !== undefined && v !== '') ? `${v} months` : '',
    parse: (v) => v ? v.toString().replace(/months/gi, '').trim() : '',
  },
  default: {
    format: (v) => (v !== null && v !== undefined) ? v : '',
    parse: (v) => v,
  },
};

export const useStringFormatter = () => {
  return {
    formatCurrency,
    formatNumbers,
    formatNumber,
    formatThousands,
    financialTableFormatters,
  };
};
